import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';
import { CustomerService } from 'src/app/services/customer.service';
import { CustomerDialogComponent } from './customer.dialog';

@Injectable({
  providedIn: 'root'
})
export class CustomerDialogService {

    constructor(public dialog: MatDialog,
        public customerService: CustomerService) {}

    public open(
        customer: CustomerInterface,
        setName: string,
        callback: any,
        onOpened?: (ref: MatDialogRef<CustomerDialogComponent>) => void
    ): void {

        // When null is passed open dialog as a "new customer mode"
        if (customer == null) {
            this.launchDialog(null, setName, callback, onOpened);
        } else {
            if (customer['_id'] != undefined) {
                this.customerService.findOne(customer['_id']).subscribe((customer: any) => {
                    this.launchDialog(customer, "", callback, onOpened);
                });
            } else {
                console.log("Customer has no ['_id']?");
            }
        }
    }

    public launchDialog(
        customer: CustomerInterface | string | null,
        setName: string | null,
        callback: any,
        onOpened?: (ref: MatDialogRef<CustomerDialogComponent>) => void
    ) {
        let dialog = this.dialog.open(CustomerDialogComponent, {
            position: {
                top: '20px'
            },
            width: '800px',
            autoFocus: false,
            data: {
                customer,
                setName
            }
        });

        if (onOpened) {
            dialog.afterOpened().subscribe(() => onOpened(dialog));
        }

        dialog.afterClosed().subscribe(r => {
            callback(r);
        })
    }
}
